import PropTypes from "prop-types";
import { Tooltip } from "antd";
import {
  getMyReactionEmoji,
  getReactionUserId,
  groupReactions,
  idsMatch,
  isReactionVip,
} from "./chatReactionUtils";
import "./chatReactions.scss";

const ChatReactionBar = ({
  reactions = [],
  currentUserId,
  onSelect,
}) => {
  const groups = groupReactions(reactions);
  if (!groups.length) return null;

  const mine = getMyReactionEmoji(reactions, currentUserId);

  return (
    <div className="chat-reaction-bar">
      {groups.map((group) => {
        const isMine = mine === group.emoji;
        const reactedByMe = group.users.some((user) =>
          idsMatch(getReactionUserId(user), currentUserId)
        );

        return (
          <Tooltip
            key={group.emoji}
            title={
              <span className="chat-reaction-tooltip">
                {group.users.map((user, index) => (
                  <span
                    key={`${getReactionUserId(user) || index}`}
                    className={isReactionVip(user) ? "is-vip" : ""}
                  >
                    {user.userName || user.user?.userName || "User"}
                    {index < group.users.length - 1 ? ", " : ""}
                  </span>
                ))}
              </span>
            }
          >
            <button
              type="button"
              className={`chat-reaction-chip${group.hasVip ? " is-vip" : ""}${
                reactedByMe || isMine ? " is-mine" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                onSelect?.(group.emoji);
              }}
              aria-label={`${group.emoji} ${group.count}`}
            >
              <span className="chat-reaction-chip__emoji">{group.emoji}</span>
              {group.count > 1 && (
                <span className="chat-reaction-chip__count">{group.count}</span>
              )}
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
};

ChatReactionBar.propTypes = {
  reactions: PropTypes.array,
  currentUserId: PropTypes.string,
  onSelect: PropTypes.func,
};

export default ChatReactionBar;
